module.exports = __webpack_public_path__ + "static/media/logo_vietcombank.6ae7ecca.svg";